const API_BASE_URL = process.env.REACT_APP_API_URL
  || (process.env.NODE_ENV === 'development' ? 'http://localhost:8000' : '');
const TOKEN_KEY = 'conveyor-belt-admin-jwt-v1';
const USER_KEY = 'conveyor-belt-admin-user-v1';

export function readAdminToken() {
  try {
    return window.sessionStorage.getItem(TOKEN_KEY) || '';
  } catch (error) {
    console.error('Unable to read admin authentication token.', error);
    return '';
  }
}

export function saveAdminToken(token) {
  window.sessionStorage.setItem(TOKEN_KEY, token);
}

export function clearAdminToken() {
  window.sessionStorage.removeItem(TOKEN_KEY);
}

export function readAdminUser() {
  try {
    const savedUser = window.sessionStorage.getItem(USER_KEY);
    if (!savedUser) return null;
    const user = JSON.parse(savedUser);
    if (user && typeof user.name === 'string' && typeof user.email === 'string') return user;
    throw new Error('Saved admin profile is invalid.');
  } catch (error) {
    console.error('Unable to read admin profile.', error);
    return null;
  }
}

export function saveAdminUser(user) {
  window.sessionStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function clearAdminUser() {
  window.sessionStorage.removeItem(USER_KEY);
}

export async function adminRequest(path, { token, method = 'GET', body } = {}) {
  const headers = { Accept: 'application/json' };
  if (body !== undefined) headers['Content-Type'] = 'application/json';
  if (token) headers.Authorization = `Bearer ${token}`;

  let response;
  try {
    response = await fetch(`${API_BASE_URL}/api${path}`, {
      method,
      headers,
      body: body === undefined ? undefined : JSON.stringify(body),
    });
  } catch (error) {
    throw new Error('Cannot reach the admin API. Check that the backend is running and try again.');
  }

  let result;
  try {
    result = await response.json();
  } catch (error) {
    throw new Error(`Admin API returned an invalid response (${response.status}).`);
  }
  if (!response.ok) {
    const requestError = new Error(result.message || `Admin API request failed (${response.status}).`);
    requestError.status = response.status;
    throw requestError;
  }
  return result;
}

export async function authenticateAdmin(mode, credentials) {
  return adminRequest(`/auth/${mode}`, { method: 'POST', body: credentials });
}

export function getWorkspace(token, scope = 'Domestic') {
  return adminRequest(`/workspace?scope=${encodeURIComponent(scope)}`, { token });
}

export function saveWorkspace(token, data, scope = 'Domestic') {
  return adminRequest('/workspace', { token, method: 'PUT', body: { data, scope } });
}

export function saveWorkspaceModules(token, modules, scope = 'Domestic') {
  return adminRequest('/workspace/modules', { token, method: 'PATCH', body: { modules, scope } });
}

export function getAdminModuleRecords(token, module, scope = 'Domestic') {
  return adminRequest(`/workspace/modules/${encodeURIComponent(module)}?scope=${encodeURIComponent(scope)}`, { token });
}

export function createAdminModuleRecord(token, module, record, scope = 'Domestic') {
  return adminRequest(`/workspace/modules/${encodeURIComponent(module)}`, {
    token,
    method: 'POST',
    body: { record, scope },
  });
}

export function updateAdminModuleRecord(token, module, recordId, record, scope = 'Domestic') {
  return adminRequest(`/workspace/modules/${encodeURIComponent(module)}/${encodeURIComponent(recordId)}`, {
    token,
    method: 'PUT',
    body: { record, scope },
  });
}

export function deleteAdminModuleRecord(token, module, recordId, scope = 'Domestic') {
  return adminRequest(`/workspace/modules/${encodeURIComponent(module)}/${encodeURIComponent(recordId)}?scope=${encodeURIComponent(scope)}`, {
    token,
    method: 'DELETE',
  });
}
